import React from 'react';
export function Footer() {
  return <footer className="bg-ink text-white/60 py-12 text-center text-sm" data-id="element-32">
      <div className="max-w-4xl mx-auto px-4" data-id="element-33">
        <p className="mb-4" data-id="element-34">
          © {new Date().getFullYear()} Padres Nutricionistas. Todos los
          derechos reservados.
        </p>
        <p className="text-xs opacity-70 max-w-2xl mx-auto leading-relaxed" data-id="element-35">
          Descargo de responsabilidad: La información contenida en este manual
          es de carácter educativo y no sustituye el consejo médico profesional,
          diagnóstico o tratamiento. Siempre busque el consejo de su pediatra u
          otro proveedor de salud calificado con cualquier pregunta que pueda
          tener sobre una condición médica.
        </p>
      </div>
    </footer>;
}